import React, { FC, RefObject, useCallback, useEffect, useMemo, useRef } from "react";
import useWebSocket from "react-use-websocket";
import { DataEventMessage, isDataEventMessage } from "../../models/DTOs";
import { QueryClient, useQueryClient } from "@tanstack/react-query";
import { debounce, isEqual, uniqWith } from "lodash-es";
import { config } from "../../const";

const Event: FC = () => {

    const queryClient = useQueryClient();

    const WS_URL = `${config.webSocketBaseUrl}/events`;
    const { lastJsonMessage } = useWebSocket(
        WS_URL,
        {
            share: true,
            shouldReconnect: () => true,
            heartbeat: {
                message: "ping",
                returnMessage: "pong",
                timeout: 60000,
                interval: 25000,
            },
        },
        config.webSocketEnabled,
    );

    const batchedDataEventMessages = useRef([] as DataEventMessage[]);

    const batchDataEventMessage =
        useCallback((batchedDataEventMessages: RefObject<DataEventMessage[]>, event: DataEventMessage) => {
            batchedDataEventMessages.current = [ ...batchedDataEventMessages.current, event ];
        }, []);


    const processBatchedDataEventMessages =
        useMemo(() =>
            debounce(
                (batchedDataEventMessages: RefObject<DataEventMessage[]>, queryClient: QueryClient) => {
                    if (batchedDataEventMessages.current.length) {
                        uniqWith(batchedDataEventMessages.current.flatMap(event => event.cacheKeys), isEqual)
                         .forEach((queryKey) => {
                                 console.log("Invalidate Queries");
                                 console.log({ queryKey });
                                 queryClient.invalidateQueries({ queryKey });
                         });
                        batchedDataEventMessages.current = [];
                    }
                },
                10000
            )
        , []);


    const processEventMessage =
        useCallback((lastJsonMessage: unknown) => {
            if (isDataEventMessage(lastJsonMessage) && lastJsonMessage.cacheKeys?.length) {
                batchDataEventMessage(batchedDataEventMessages, lastJsonMessage);
                processBatchedDataEventMessages(batchedDataEventMessages, queryClient);
            }
        }, [ batchDataEventMessage, processBatchedDataEventMessages, queryClient ]);


    // Run when a new WebSocket message is received (lastJsonMessage / lastMessage)
    useEffect(() => {
        processEventMessage(lastJsonMessage);
    }, [ lastJsonMessage, processEventMessage ]);


    return (
        <></>
    );
};

export default Event;
